<template>
  <RouterLink v-focus :to="to" class="side-menu-locked-item">
    <i :class="iconClass" />

    <Transition name="fade">
      <span
        v-show="!isMenuCollapsed && isTransitionEnded"
        class="side-menu-locked-item__content"
      >
        {{ name }}

        <i class="side-menu-locked-item__permission-icon">
          <PermissionLevelIcon :permission-level="permissionLevel" />
        </i>
      </span>
    </Transition>
  </RouterLink>
</template>

<script setup>
import { computed } from "vue";
import { useSideMenu } from "@follaw-fr/composables/useSideMenu";
import PermissionLevelIcon from "@follaw-fr/components/general/atoms/PermissionLevelIcon.vue";

const props = defineProps({
  name: { type: String, required: true },
  to: { type: String, required: true },
  iconClass: { type: String, required: true },
  iconClassActive: { type: String, required: false },
  permissionLevel: { type: String, required: true },
  isMenuCollapsed: { type: Boolean, default: false },
  isTransitionEnded: { type: Boolean, default: false },
});

const { isActive } = useSideMenu();

const iconClass = computed(() => {
  return isActive({ path: props.to })
    ? props.iconClassActive ?? props.iconClass
    : props.iconClass;
});
</script>

<style scoped lang="scss">
.side-menu-locked-item {
  --item-height: 40px;

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  color: var(--clr-n1);
  font-size: 0.9rem;
  letter-spacing: -0.2px;
  min-height: var(--item-height);
  max-height: var(--item-height);

  &:hover {
    background-color: var(--clr-p7);
    color: var(--clr-n1);
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;

    &:hover {
      text-decoration: underline;
    }
  }

  &__permission-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
